import T from '../types';

export default fromCityId => {
  return {
    type: T.CHANGE_DEPARTURE_CITY,
    fromCityId,
  };
};
